const messagesIt = {
  about: 'Informazioni',
  acceptanceCriteria: 'Criteri di Accettazione',
  accomplishments: 'Risultati',
  actions: 'Azioni',
  activity: 'Attività',
  activatePod: 'Attiva POD',
  activePods: 'POD Attivi',
  add: 'Aggiungi',
  addBlocker: 'Aggiungi Informazioni Blocco',
  addingCandidateWait: 'Aggiunta candidato in corso, attendere...',
  addPortfolio: 'Aggiungi Portfolio',
  addStakeholder: 'Aggiungi Stakeholder',
  addVideoUpdate: 'Aggiungi Aggiornamento Video',
  findAgents: 'Trova Agenti',
  all: 'Tutti',
  allReporters: 'Tutti i Reporter',
  allRepoCheckins: 'Tutti i Check-in Repository',
  approve: 'Approva',
  approved: 'Approvato',
  approvalRequests: 'Richieste di Approvazione',
  approvedPRCount: 'Conteggio PR Approvate',
  assignedItems: 'Elementi Assegnati',
  availability: 'Disponibilità',
  availableDate: 'Data disponibile',
  backToPods: 'Torna ai Miei POD',
  basicInformation: 'Informazioni Base',
  blocker: 'Blocco',
  blockerDetails: 'Dettagli Blocco',
  blockers: 'Blocchi',
  board: 'Bacheca',
  browseTalent: 'Sfoglia Talenti',
  bugs: 'Bug',
  calendlyUrl: 'URL Calendly',
  cancel: 'Annulla',
  candidates: 'Candidati',
  categories: 'Categorie',
  certifications: 'Certificazioni',
  certificationUrl: 'URL Certificazione',
  checkBoxBlocker: 'Seleziona questa casella se è un blocco',
  ciCdPipeline: 'Pipeline CI/CD',
  clear: 'Cancella',
  client: 'Cliente',
  clickHereUploadVideoClip: 'Clicca qui per caricare un video clip!',
  cloudCost: 'Costo Cloud',
  code: 'Righe di Codice',
  codeSmells: 'Code Smell',
  commentHere: 'commenta qui...',
  category: 'Categoria',
  comments: 'Commenti',
  companyName: 'Nome Azienda',
  copied: 'Copiato!',
  copyright: 'Copyright © 2025-presente Brilli Global, Inc. Tutti i diritti riservati.',
  copyToClipboard: 'Copia negli appunti',
  cost: 'Costo',
  costDetails: 'Dettagli Costo',
  country: 'Paese',
  create: 'Crea',
  createArt: 'Crea ART',
  createGig: 'Crea Soluzione',
  createPod: 'Crea POD',
  createProfile: 'Crea Profilo',
  createProfileOpportunity: 'Crea il tuo profilo nel nostro database di talenti per essere incluso in varie opportunità di lavoro remoto.',
  createTask: 'Crea Attività',
  createYourOwnPod: 'Crea il tuo POD e naviga i progetti',
  creatingProfile: 'Creazione profilo',
  currency: 'Valuta',
  currentlyAvailable: 'Attualmente Disponibile',
  currentWeek: 'Settimana Corrente',
  dashboard: 'Dashboard',
  date: 'Data',
  dateRangeFilter: 'Filtro Intervallo Date',
  deactivatePod: 'Disattiva POD',
  deactivateToUpdate: 'Disattiva il POD per Aggiornare il POD!',
  defects: 'Difetti',
  delete: 'Elimina',
  deletePod: 'Elimina POD',
  description: 'Descrizione',
  detailsForGitHubRepo: 'Dettagli per Repository GitHub',
  done: 'chiudi',
  Done: 'FATTO',
  doraMetrics: 'Metriche Dora',
  dueDate: 'Data di Scadenza',
  duplicatedLinesDensity: 'Densità Righe Duplicate',
  edit: 'Modifica',
  education: 'Istruzione',
  educationAndCertifications: 'Istruzione e Certificazioni',
  email: 'Email',
  podTime: 'Tempo POD',
  createHub: 'Crea Hub',
  createSolution: 'Crea Soluzione',
  podVelocity: 'Velocità POD',
  podBlockers: 'Blocchi POD',
  podsync: 'Sincronizzazione POD',
  endDate: 'Data fine',
  enterEmailToInvite: 'Inserisci un\'email per invitare',
  enterPodMission: 'Inserisci Missione POD',
  enterPodName: 'Inserisci Nome POD',
  enterStoryDescription: 'Inserisci una Descrizione della Storia',
  executionDate: 'Data di Esecuzione',
  executionID: 'ID Esecuzione',
  externalPod: 'POD Esterno',
  fileNameNoSpaces: 'Il nome del file non dovrebbe includere spazi tra tutti gli elementi o caratteri',
  fileUpload: 'Caricamento File',
  findBestFreelancers: 'Trova i migliori freelancer o POD di talenti per far consegnare i tuoi progetti a un ritmo più veloce!',
  findBestPod: 'Trova POD che corrispondono alla tua esperienza/set di competenze',
  findPods: 'Trova POD',
  findTalent: 'Trova Talenti',
  findYourBestTalentPod: 'Trova il tuo miglior POD di talenti',
  firstName: 'Nome',
  focus: 'Focus',
  gitHubRepo: 'Repository GitHub',
  gitHubUsername: 'Nome Utente GitHub',
  github: 'Github',
  githubSummary: 'Riepilogo GitHub',
  githubUrl: 'URL Github',
  githubUser: 'Utente GitHub',
  giveRating: 'Dai Valutazione',
  globalWorkPlatform: 'Piattaforma di Lavoro Globale',
  home: 'Home',
  hoursPerWeek: 'Ore per Settimana',
  inactivePod: 'POD Inattivo',
  individual: 'Individuale',
  industry: 'Settore',
  inProgress: 'IN CORSO',
  institute: 'Istituto',
  internalPod: 'POD Interno',
  invite: 'Invita',
  invoices: 'Fatture',
  issueKey: 'Chiave Issue',
  issueStatus: 'Stato Issue',
  issueSummary: 'Riepilogo Issue',
  jiraIssue: 'Issue Jira',
  jiraIssues: 'Issue Jira',
  jiraItem: 'Elemento Jira',
  jiraTimeDetails: 'Log Tempo',
  jiraUsername: 'Nome Utente Jira',
  keepDoing: 'Continua a Fare',
  keyword: 'Parola Chiave',
  languageSpoken: 'Lingua Parlata',
  lastName: 'Cognome',
  latestSprintVelocity: 'Ultima Velocità Sprint',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'URL LinkedIn',
  linesOfCodeByDay: 'Righe di Codice per Giorno',
  listOfTalents: 'Lista Talenti',
  loading: 'Caricamento',
  loadingAcceptanceCriteria: 'Caricamento Criteri di Accettazione',
  loadingStoryDescription: 'Caricamento Descrizione Storia',
  loadingTestCases: 'Caricamento Test Case',
  logOut: 'Esci',
  login: 'Accedi',
  manage: 'Gestisci',
  manageActivities: 'Gestisci le tue attività POD quotidiane e gli aggiornamenti',
  manageProfile: 'Gestisci profilo',
  manageProfileHere: 'Gestisci il tuo profilo qui',
  managePod: 'Gestisci POD',
  managePods: 'Gestisci tutti i tuoi POD e le loro attività',
  markComplete: 'Segna Completato',
  middleName: 'Secondo Nome',
  myPods: 'I Miei POD',
  myTasks: 'Le Mie Attività',
  name: 'Nome',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Nuovo Aggiornamento Attività',
  next: 'Successivo',
  noArtOptionsAvailable: 'Nessuna Opzione ART Disponibile',
  noBlockers: 'Non Ci Sono blocchi',
  noCandidates: 'Nessun Candidato Aggiunto',
  noCandidatesAddedToPod: 'Nessun Candidato Aggiunto al POD!',
  noCandidateReviews: 'Non ci sono recensioni di candidati.',
  noData: 'Nessun Dato',
  noDataAvailable: 'Nessun dato disponibile',
  noExperience: 'Nessuna Esperienza',
  noMatchingPods: 'Non ci sono POD corrispondenti disponibili',
  noNotifications: 'Non ci sono notifiche',
  noPodActivity: 'Non Hai Nessuna Attività POD',
  noPods: 'Non hai nessun POD',
  noPodTasks: 'Non hai nessuna Attività POD',
  noReviews: 'Non ci sono recensioni.',
  noStakeholders: 'Non Ci Sono stakeholder per questo POD',
  noSubscription: 'Non hai nessun piano di abbonamento',
  noVideoAvailable: 'Nessun video disponibile',
  notifications: 'Destinatario Notifiche',
  otherInformation: 'Altre Informazioni',
  pending: 'In Attesa',
  pendingPods: 'POD in Attesa',
  phoneNumber: 'Numero di Telefono',
  pipelineExecutionDetails: 'Dettagli Esecuzione Pipeline',
  pipelineName: 'Nome Pipeline',
  pipelineVersion: 'Versione Pipeline',
  pleaseEnterStoryDescription: 'Per favore inserisci una descrizione della storia e clicca invia',
  POD: 'POD',
  podActivities: 'Attività POD',
  podActivity: 'Attività POD',
  podAnalytics: 'Analisi POD',
  podAssist: 'Assistente POD',
  podAutomation: 'Automazione POD',
  podBoard: 'Bacheca POD',
  podCategories: 'Categorie POD',
  podDescription: 'Descrizione POD',
  podExperience: 'Esperienza POD',
  podFeedback: 'Feedback POD',
  podMetrics: 'Metriche POD',
  podName: 'Nome POD',
  podQuery: 'Query POD',
  podRequests: 'RICHIESTE POD',
  podRetro: 'Retrospettiva POD',
  podSize: 'Dimensione POD',
  podTasks: 'Attività POD',
  podTaskDescription: 'Descrizione Attività POD',
  podTaskDueDate: 'Data Scadenza Attività POD',
  podTaskName: 'Nome Attività POD',
  podTaskOwner: 'Proprietario Attività POD',
  podTaskStatus: 'Stato Attività POD',
  podTechStack: 'Stack Tecnologico POD',
  podTeamMember: 'Membro Team POD',
  podType: 'Tipo POD',
  portfolio: 'Portfolio',
  portfolioUrl: 'URL Portfolio',
  post: 'Pubblica',
  postActivity: 'Pubblica Attività',
  postPodActivity: 'Pubblica Attività POD',
  postRequirement: 'Pubblica Requisito',
  posting: 'Pubblicazione...',
  postedDate: 'Data Pubblicazione',
  postedRequirements: 'I Tuoi Requisiti POD Pubblicati',
  positionName: 'Nome Posizione',
  prCount: 'Conteggio PR',
  preferredWorkHours: 'Orari di Lavoro Preferiti',
  prev: 'Precedente',
  previousPods: 'POD Precedenti',
  previousWeek: 'Settimana Precedente',
  primarySkill: 'Competenza Primaria',
  privacyPolicy: 'Politica sulla Privacy',
  privatePods: 'POD Privati',
  prSummary: 'Riepilogo PR',
  projectKey: 'Chiave Progetto',
  profileLink: 'Link Profilo',
  profileVisibility: 'Visibilità Profilo',
  public: 'Pubblico',
  qualification: 'Qualifica',
  ratePerHour: 'Tariffa Oraria',
  ratePerMonth: 'Tariffa Mensile',
  recentSearches: 'Ricerche Recenti',
  region: 'Regione',
  register: 'Registrati',
  resetPassword: 'Reimposta Password',
  restricted: 'Limitato',
  retro: 'Retrospettiva',
  review: 'Recensione e Valutazione',
  revisionSummary: 'Riepilogo Revisione',
  revisionURL: 'URL Revisione',
  resume: 'Curriculum',
  resumeLink: 'Visualizza Curriculum',
  rowsPerPage: 'Righe per pagina',
  save: 'Salva',
  search: 'Cerca',
  searchProjects: 'Cerca progetti',
  secondarySkill: 'Competenza Secondaria',
  select: 'Seleziona',
  selectArtName: 'Seleziona Nome ART',
  selectAUser: 'Seleziona un Utente',
  selectFilter: 'Seleziona Filtro',
  applyFilters: 'Applica Filtri',
  selectItemsPerPage: 'Seleziona elementi per pagina',
  selectJiraIssues: 'Seleziona Issue Jira',
  selectPod: 'Seleziona un POD',
  selectPodTeamMember: 'Seleziona Membro Team POD',
  selectPods: 'Seleziona POD',
  services: 'Servizi',
  setting: 'Impostazione',
  shareableLink: 'Link Condivisibile',
  signUpToGetStarted: '"Registrati" qui sotto per Iniziare!',
  getStarted: 'Inizia',
  skills: 'Competenze',
  skillsAndExpertise: 'Competenze ed Esperienza',
  sonarqubeprojectkey: 'Chiave Progetto Sonarqube',
  sonarqubeStats: 'Statistiche Sonarqube',
  specialization: 'Specializzazione',
  sprintVelocity: 'Velocità Sprint',
  sprint: 'Sprint',
  spotsLeft: 'Posti Rimasti',
  startDate: 'Data inizio',
  startDoing: 'Inizia a Fare',
  status: 'Stato',
  stopDoing: 'Smetti di Fare',
  storyDescription: 'Descrizione Storia',
  stories: 'Storie',
  submit: 'Invia',
  submittedDate: 'Data Invio',
  submittedPRCount: 'Conteggio PR Inviate',
  subscription: 'Abbonamento',
  talentApprovalRequests: 'Richieste Approvazione Talenti',
  talentCode: 'Codice Talento',
  taskForm: 'Modulo Attività',
  taskManager: 'Gestore Attività',
  taskName: 'Nome Attività',
  tasks: 'Attività',
  teamMember: 'Membro Team',
  techStack: 'Stack Tecnologico',
  termsOfService: 'Termini di Servizio',
  testCases: 'Test Case',
  time: 'Tempo',
  timeLog: 'Log Tempo',
  timeSubmit: 'Invio Tempo',
  timeZone: 'Fuso Orario',
  toDo: 'DA FARE',
  todaysFocus: 'Focus di Oggi',
  totalLinesChangedLastWeek: 'Totale Righe Cambiate Settimana Scorsa',
  totalLinesChangedThisWeek: 'Totale Righe Cambiate Questa Settimana',
  totalPRCount: 'Conteggio Totale PR',
  university: 'Università',
  update: 'Aggiorna',
  updateProfileHere: 'Aggiorna il tuo profilo qui',
  updatingVisibility: 'Aggiornamento visibilità...',
  upload: 'Carica',
  userStory: 'Storia Utente',
  validFrom: 'Valido da',
  validTill: 'Valido fino a',
  talentexplorer: 'Esploratore Talenti',
  interviewrequests: 'Richieste Colloquio',
  videoUrl: 'URL Video',
  view: 'Visualizza',
  viewActivities: 'Visualizza Attività',
  viewDetails: 'Visualizza Dettagli',
  viewPodActivities: 'Visualizza Attività POD',
  viewPodDetails: 'Visualizza Dettagli POD',
  viewProfile: 'Visualizza Profilo',
  viewTasks: 'Visualizza Attività',
  viewTimeEntries: 'Visualizza Voci Tempo',
  viewVideo: 'Visualizza Video',
  visitFindTalent: 'Per favore visita la pagina "Trova Talenti" e aggiungi individui talentuosi al tuo POD.',
  vulnerabilities: 'Vulnerabilità',
  welcome: 'Benvenuto in Artemy.ai!',
  workExperience: 'Esperienza Lavorativa',
  yourPod: 'Il Tuo POD',
  yourPods: 'I Tuoi POD',
  yourPostedPodActivity: 'La Tua Attività POD Pubblicata',
  
  findTickets: 'Trova Ticket',
  epics: 'Epiche',
  date: 'Data',
  talent: 'Talento',
  focus: 'Focus',
  startDate: 'Data Inizio',
  endDate: 'Data Fine',
  status: 'Stato',
  allStatus: 'Tutti gli Stati',
  blocked: 'Bloccato',
  onTrack: 'Sulla Buona Strada',
  activityDetails: 'Dettagli Attività',
  jiraIssues: 'Issue Jira',
  todaysFocus: 'Focus di Oggi',
  accomplishments: 'Risultati',
  blockers: 'Blocchi',
  videoUpdate: 'Aggiornamento Video',
  comments: 'Commenti',
  addBlockerInformation: 'Aggiungi Informazioni Blocco',
  blockerDetails: 'Dettagli Blocco',
  cancel: 'Annulla',
  saveChanges: 'Salva Modifiche',
  selectJiraIssues: 'Seleziona Issue Jira',
  design: 'Design',
  development: 'Sviluppo',
  testing: 'Test',
  bugFix: 'Correzione Bug',
  documentation: 'Documentazione',
  myPods: 'I Miei POD',
  postRetro: 'Pubblica Retrospettiva',
  newRetro: 'Nuova Retrospettiva',
  startDoing: 'Inizia a Fare',
  stopDoing: 'Smetti di Fare',
  keepDoing: 'Continua a Fare',
  viewRetros: 'Visualizza Retrospettive',
  podRetroFeedback: 'Feedback Retrospettiva POD',
  selectSprint: 'Seleziona Sprint',
  thisTaskIsBlocker: 'Questa attività è un blocco',
  category: 'Categoria',
  taskCreatedSuccessfully: 'Attività creata con successo!',
  taskManagement: 'Gestione Attività',
  searchJiraIssues: 'Cerca issue JIRA...',
  creatingTask: 'Creazione Attività...',
  createTask: 'Crea Attività',
  description: 'Descrizione',
  dueDate: 'Data scadenza',
  commentsHistory: 'Cronologia Commenti',
  noCommentsYet: 'Nessun commento ancora',
  writeAComment: 'Scrivi un commento...',
  all: 'Tutti',
  blockerStatus: 'Stato Blocco',
  blockedTasks: 'Attività Bloccate',
  unblockedTasks: 'Attività Non Bloccate',
  clearDateRange: 'Cancella Intervallo Date',
  selectDateRange: 'Seleziona Intervallo Date',
  showAllTime: 'Mostra Tutto il Tempo',
  noTasksFound: 'Nessuna attività trovata',
  noLinkedIssues: 'Nessuna issue collegata',
  timeSheet: 'Foglio Ore',
  podTimeSheet: 'Foglio Ore POD',
  userStory: 'Storia Utente',
  hours: 'Ore',
  minutes: 'Minuti',
  actions: 'Azioni',
  submitTimeEntries: 'Invia Voci Tempo',
  selectCategory: 'Seleziona Categoria',
  selectStory: 'Seleziona Storia',
  addRow: 'Aggiungi Riga',
  podSelection: 'Selezione POD',
  selectPodToView: 'Seleziona un POD per visualizzare i filtri sprint e talenti',
  toDo: 'Da Fare',
  podAssist: 'Assistente POD',
  inProgress: 'In Corso',
  done: 'Fatto',
  selectPodsRequired: 'Seleziona POD (Richiesto)',
  enterStoryDescription: 'Inserisci una Descrizione della Storia',
  podSyncSummaries: 'Riepiloghi Sincronizzazione POD',
  enterMeetingUrl: 'Inserisci URL meeting...',
  searchInSummaries: 'Cerca nei riepiloghi...',
  dateAndTime: 'Data e Ora',
  quickTimeRange: 'Intervallo Tempo Rapido',
  sortByDate: 'Ordina per Data',
  selectTalents: 'Seleziona Talenti',
  filterBySpecificCandidates: 'Filtra per candidati specifici (opzionale)',
  talentSelection: 'Selezione Talenti',
  priority: 'Priorità',
  addComment: 'Aggiungi Commento',
  taskDetails: 'Dettagli Attività',
  summary: 'Riepilogo',
  addMeeting: 'Aggiungi Meeting',

  podAutomation: 'Automazione POD',
  uploading: 'Caricamento...',
  uploadFile: 'Carica File',
  send: 'Invia',
  submitting: 'Invio...',
  enterYourQuestionHere: 'Inserisci la tua domanda qui',
  submitTheResults: 'Invia i risultati',
  export: 'Esporta',
  podInsights: 'Insights POD',
  askQuestionsAboutYourPod: 'Fai domande sulle tue attività POD, membri del team e altro',
  welcomeToPodInsights: 'Benvenuto in POD Insights!',
  startByAskingQuestionsLike: 'Inizia facendo domande come',
  showAllPodActivitiesThatHadBlockers: 'Mostra tutte le attività POD che avevano blocchi',
  listAllCandidatesAndTheirPods: 'Elenca tutti i candidati e i loro POD',
  showStakeholdersFromIndia: 'Mostra stakeholder dall\'India',
  askAnythingAboutYourPods: 'Chiedi qualsiasi cosa sui tuoi POD, membri del team, attività...',
  sending: 'Invio...',
  analyzingYourQuestion: 'Analizzando la tua domanda...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Ticket',
  metricName: 'Nome Metrica',
  metricValue: 'Valore Metrica',
  commentsHistory: 'Cronologia Commenti',
  noCommentsYet: 'Nessun commento ancora',
  writeAComment: 'Scrivi un commento...',
  solutionManagement: 'Gestione Soluzioni',
  searchSolutions: 'Cerca Soluzioni...',
  refresh: 'Aggiorna',
  createNewSolution: 'Crea Nuova Soluzione',
  solutionName: 'Nome Soluzione',
  solutionDescription: 'Descrizione Soluzione',
  updateSolution: 'Aggiorna Soluzione',
  createSolution: 'Crea Soluzione',
  confirmSolutionDeletion: 'Sei sicuro di voler eliminare la Soluzione',
  artManagement: 'Gestione ART',
  podManagement: 'Gestione POD',
  searchPods: 'Cerca POD...',
  viewPod: 'Visualizza POD',
  searchARTs: 'Cerca ART...',
  noARTsFound: 'Nessun ART trovato. Crea il tuo primo ART cliccando il pulsante "Crea Nuovo ART".',
  createNewART: 'Crea Nuovo ART',
  selectGig: 'Seleziona Gig',
  artName: 'Nome ART',
  artDescription: 'Descrizione ART',
  createART: 'Crea ART',
  confirmDeletion: 'Conferma Eliminazione',
  confirmARTDeletion: 'Sei sicuro di voler eliminare l\'ART',
  primaryLanguage: 'Lingua Primaria',
  selectSkills: 'Seleziona Competenze',
  timeZone: 'Fuso Orario',
  updateART: 'Aggiorna ART',
  somethingWentWrong: 'Qualcosa è andato storto',
  reloadPage: 'Ricarica Pagina',
  privatePods: 'POD Privati',
  activePods: 'POD Attivi',
  completedPods: 'POD Completati',
  pendingPods: 'POD in Attesa',
  loadingPods: 'Caricamento POD...',
  retry: 'Riprova',
  noPodsFound: 'Nessun POD trovato',
  createFirstPod: 'Crea il tuo primo POD per iniziare',
  previous: 'Precedente',
  showing: 'Mostrando',
  size: 'Dimensione',
  teamSize: 'Dimensione Team',
  activeMembers: 'Membri Attivi',
  stakeholders: 'Stakeholder',
  podManagers: 'Manager POD',
  addManager: 'Aggiungi Manager',
  podManager: 'Manager POD',
  noManagersAssignedYet: 'Nessun manager assegnato ancora',
  addManagersToHelpOversee: 'Aggiungi manager per aiutare a supervisionare questo POD',
  noStakeholdersYet: 'Nessun stakeholder ancora',
  settings: 'Impostazioni',
  deletePod: 'Elimina POD',
  addPodManager: 'Aggiungi Manager POD',
  selectManagerToInvite: 'Seleziona un manager da invitare a questo POD:',
  noManagersAvailableToInvite: 'Nessun manager disponibile da invitare.',
  selectAManager: 'Seleziona un manager',
  selectedManager: 'Manager Selezionato',
  inviteManager: 'Invita Manager',
  noTeamMembersYet: 'Nessun membro del team ancora',
  startByInvitingMembers: 'Inizia invitando membri al tuo POD',
  inviteTeamMembers: 'Invita Membri del Team',
  existingMembers: 'Membri Esistenti',
  inviteByEmail: 'Invita tramite Email',
  searchByNameOrSkills: 'Cerca per nome o competenze...',
  optionalSelectUserToNotify: 'Opzionale: Seleziona un utente da notificare tramite Slack',
  pleaseSelectPodToEnableFields: 'Per favore seleziona un POD per abilitare altri campi',
  selectedCandidates: 'Candidati Selezionati',
  selectCandidatesToInvite: 'Seleziona candidati da invitare a questo POD',
  availableCandidates: 'Candidati Disponibili',
  inviteNewMembersByEmail: 'Invita Nuovi Membri tramite Email',
  emailAddresses: 'Indirizzi Email',
  enterEmailAddresses: 'Inserisci indirizzi email (separati da virgole)',
  hidePodTeamMembers: 'Nascondi i membri del team di questo POD nella sezione Trova POD (Attualmente Visibile)',
  technicalDetails: 'Dettagli Tecnici',
  currentTeamSize: 'Dimensione attuale del team',
  communicationDetails: 'Dettagli Comunicazione',
  podReview: 'Recensione POD',
  rating: 'Valutazione',
  writeReview: 'Scrivi Recensione',
  shareYourExperience: 'Condividi la tua esperienza con questo POD...',
  submitReview: 'Invia Recensione',
  viewPod: 'Visualizza POD',
  managePod: 'Gestisci POD',
  editPod: 'Modifica POD',
  skillsAndExperience: 'Competenze ed Esperienza',
  reviews: 'Recensioni',
  documents: 'Documenti',
  otherInfo: 'Altre Informazioni',
  noWorkExperienceDataAvailable: 'Nessun dato esperienza lavorativa disponibile',
  selectART: 'Seleziona ART',
  selectAnART: 'Seleziona un ART',
  jiraConfiguration: 'Configurazione Jira',
  jiraProjectKey: 'Chiave Progetto Jira',
  jiraURL: 'URL Jira',
  jiraAdminEmail: 'Email Admin Jira',
  jiraAdminAPIToken: 'Token API Admin Jira',
  jiraOpenStoryBugStatus: 'Stato Storia/Bug Aperto Jira',
  jiraClosedStoryBugStatus: 'Stato Storia/Bug Chiuso Jira',
  gitHubConfiguration: 'Configurazione GitHub',
  gitHubUsername: 'Nome Utente GitHub',
  gitHubAPIToken: 'Token API GitHub',
  gitHubRepositoryName: 'Nome Repository GitHub',
  circleCIConfiguration: 'Configurazione CircleCI',
  circleCIGitHubUsername: 'Nome Utente GitHub CircleCI',
  circleCIGitHubRepository: 'Repository GitHub CircleCI',
  circleCIAPIToken: 'Token API CircleCI',
  sonarQubeConfiguration: 'Configurazione SonarQube',
  sonarQubeCloudURL: 'URL SonarQube Cloud',
  sonarQubeAPIToken: 'Token API SonarQube',
  awsConfiguration: 'Configurazione AWS',
  awsAccessKeyID: 'ID Chiave Accesso AWS',
  awsSecretAccessKey: 'Chiave Accesso Segreto AWS',
  awsRegion: 'Regione AWS',
  bitBucketConfiguration: 'Configurazione BitBucket',
  bitBucketUsername: 'Nome Utente BitBucket',
  bitBucketAppPassword: 'Password App BitBucket',
  bitBucketWorkspace: 'Workspace BitBucket',
  openAIConfiguration: 'Configurazione OpenAI',
  openAIToken: 'Token OpenAI',
  storyPointsCalculation: 'Calcolo Story Points',
  uploadStoryPointsCalculationFile: 'Carica File Calcolo Story Points',
  currentFile: 'File corrente',
  notifications: 'Notifiche',
  markAllAsRead: 'Segna tutto come letto',
  tryAgain: 'Riprova',
  noNotificationsToDisplay: 'Nessuna notifica da visualizzare',
  viewAllNotifications: 'Visualizza Tutte le Notifiche',
  enterMultipleEmailsSeparatedByCommas: 'Inserisci più email separate da virgole',
  addEmailAddressesToInvite: 'Aggiungi indirizzi email per invitare nuovi membri',
  emailInvitationGuidelines: 'Linee Guida Invito Email',
  inviteesWillReceiveInstructions: 'Gli invitati riceveranno istruzioni per unirsi a questo POD',
  theyWillNeedToCreateAccount: 'Dovranno creare un account se non ne hanno già uno',
  noCandidatesAvailable: 'Nessun candidato disponibile',
  sendEmailInvites: 'Invia Inviti Email',

  processingDataAndGeneratingInsights: 'Elaborazione dati e generazione insights',
  retroHistory: 'Cronologia Retrospettive',
  filterByMember: 'Filtra per Membro',
  podProductivity: 'Produttività POD',
  totalTasks: 'Totale Attività',
  completed: 'Completato',
  clearFilters: 'Cancella Filtri',
  totalActivities: 'Totale Attività',
  pendingApproval: 'Approvazione in Attesa',
  sortBy: 'Ordina per',
  editSolution: 'Modifica Soluzione',
  cannotDeleteAssociatedWithARTs: 'Impossibile eliminare - associato con ART',
  editART: 'Modifica ART',
  createdDate: 'Data Creazione',
  podDetails: 'Dettagli POD',
  currentARTProject: 'ART/Progetto Corrente',
  artProject: 'ART/Progetto',
  selectAvailability: 'Seleziona Disponibilità',
  selectSkill: 'Seleziona Competenza',
  selectTimezone: 'Seleziona Fuso Orario',
  selectLocation: 'Seleziona Posizione',
  selectBudget: 'Seleziona Budget',
  podMember: 'Membro POD',
  addToPod: 'Aggiungi al POD',
  talentDetails: 'Dettagli Talento',
  reviewsFeedback: 'Recensioni e Feedback',
  noEducationDataAvailable: 'Nessun dato istruzione disponibile',
  noCertificationDataAvailable: 'Nessun dato certificazione disponibile',
  clientReview: 'Recensione Cliente',
  noReviewsAvailableYet: 'Nessuna recensione disponibile ancora',
  noClientReviews: 'Questo talento non ha ricevuto recensioni cliente finora',
  resumeAvailable: 'Curriculum Disponibile',
  viewDownloadResume: 'Visualizza o scarica il curriculum del candidato',
  noResumeAvailable: 'Nessun Curriculum Disponibile',
  noResumeUploaded: 'Questo talento non ha caricato un curriculum.',
  codingAssessment: 'Valutazione Programmazione',
  assessmentAvailable: 'Valutazione Disponibile',
  viewAssessmentResults: 'Visualizza i risultati della valutazione programmazione del candidato',
  noAssessmentAvailable: 'Nessuna Valutazione Disponibile',
  noAssessmentCompleted: 'Questo talento non ha completato una valutazione programmazione.',
  partnerCompanyDetails: 'Dettagli Azienda Partner',
  companyIntroductionVideo: 'Video Presentazione Azienda',
  videoNotSupported: 'Il tuo browser non supporta il tag video.',
  location: 'Posizione',
  noPodsMatchingCriteria: 'Nessun POD trovato che corrisponda ai tuoi criteri',
  hirePod: 'Assumi POD',
  notificationHistory: 'Cronologia Notifiche',
  filter: 'Filtro',
  allNotifications: 'Tutte le Notifiche',
  markSelected: 'Segna Selezionati',
  unread: 'Non letto',
  noNotificationsFound: 'Nessuna notifica trovata',
  searchNotifications: 'Cerca notifiche...',
  
subscriptionManagement: 'Gestione Abbonamenti',
  choosePlanPrompt: 'Scegli un piano che si adatti meglio alle tue esigenze e scala man mano che cresci',
  cancelSubscription: 'Cancella Abbonamento',
  choosePlan: 'Scegli Piano',
  noPlansAvailable: 'Nessun Piano Disponibile',
  noPlansHelpText: 'Si prega di controllare più tardi o contattare il supporto per assistenza.',
  currentPlanDetails: 'Dettagli Piano Attuale',
  renewalDate: 'Data di Rinnovo',
  subscriptionId: 'ID Abbonamento',
  paymentMethod: 'Metodo di Pagamento',
  cardHolder: 'Titolare della Carta',
  expires: 'Scade',
  brand: 'Marca',
  billingHistory: 'Cronologia Fatturazione',
  noInvoiceHistory: 'Nessuna cronologia fatture disponibile',
  needHelp: 'Hai Bisogno di Aiuto?',
  supportText: 'Se hai domande sui nostri piani di abbonamento o hai bisogno di assistenza, il nostro team di supporto è qui per aiutarti.',
  contactSupport: 'Contatta Supporto',
  completeSubscription: 'Completa il Tuo Abbonamento',
  planDetails: 'Dettagli Piano',
  planName: 'Nome Piano',
  basePrice: 'Prezzo Base',
  numberOfUsers: 'Numero di Utenti',
  billingCycle: 'Ciclo di Fatturazione',
  orderSummary: 'Riepilogo Ordine',
  annualDiscount: 'Sconto Annuale',
  billingPeriod: 'Periodo di Fatturazione',
  tax: 'Tassa',
  totalWithTax: 'Totale con Tasse',
  annually: 'annualmente',
  continue: 'Continua',
  subscriptionSuccessful: 'Abbonamento Riuscito!',
  thankYouSubscribing: 'Grazie per esserti abbonato a',
  subscriptionActivated: 'Il tuo abbonamento è stato attivato con successo.',
  goToDashboard: 'Vai alla Dashboard',
  addPaymentMethod: 'Aggiungi Metodo di Pagamento',
  cardNumber: 'Numero Carta',
  cardholderName: 'Nome Titolare Carta',
  expiryMonth: 'Mese di Scadenza',
  expiryYear: 'Anno di Scadenza',
  postalCode: 'Codice Postale',
  addCard: 'Aggiungi Carta',
  paymentChoice: 'Usa Carta Esistente o Aggiungi Nuova Carta',
  existingCardText: 'Hai già una carta esistente che termina con',
  useExistingCardPrompt: 'Vorresti usarla per questo abbonamento?',
  useExistingCard: 'Usa Carta Esistente',
  addNewCard: 'Aggiungi Nuova Carta',
  processing: 'Elaborazione...',
  subscriptionSuccessDetails: 'è riuscito!',
  accessAllFeatures: 'Ora puoi accedere a tutte le funzionalità incluse nel tuo piano di abbonamento.',
  editCardDetails: 'Modifica Dettagli Carta',
  managerInvite: 'Invito Manager',
  talentInvite: 'Invito Talento',
  invitePodManagers: 'Inserisci E-Mail per Invitare Manager Pod',
  enterEmail: 'Inserisci E-Mail',
  invite: 'Invita',
  yourInvoices: 'Le Tue Fatture',
  noInvoices: 'Non hai fatture.',
  amountDue: 'Importo Dovuto',
  getCountIsseswithNoCritria: 'Ottieni il conteggio dei problemi senza criteri di accettazione',
  amountPaid: 'Importo Pagato',
  noActiveSubscription: 'Non hai un piano di abbonamento attivo. Si prega di cliccare sul link "Abbonati" per aggiungere un abbonamento.',
  noActiveSubscriptionStart: 'Non hai un piano di abbonamento attivo. Si prega di cliccare sul',
  subscribe: 'Abbonati',
  noActiveSubscriptionEnd: 'link per aggiungere un abbonamento.'};

export default messagesIt;